import React from 'react';
import { connect } from 'react-redux';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import {Link} from "react-router-dom";
import {Table} from "react-bootstrap";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import IntlFormInlineSelector from "../intlForm/IntlFormInlineSelector";
import {getNameInCurrentLanguage} from "../../helpers/intl";

class Templates extends React.Component {
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      urlData,
      list,
      appIntl
    } = this.props;
    const columns = [messages.name, messages.title, messages.initialize, messages.actions];
    const tBody = [];

    for (let i = 0; i < list.data.list.length; i++) {
      const productTemplate = list.data.list[i];
      const { id, name, title, initialized, target } = productTemplate;

      const detailsUrl = appIntl.urlPrefix + 'account/settings/producttemplates/' + id;

      tBody.push(
        <tr key={i}>
          <td>
            <IntlFormInlineSelector /> {getNameInCurrentLanguage(name, appIntl)}
          </td>
          <td>{title}</td>
          <td>{initialized ? <i className="fa fa-check-circle bg-green padding-5"/> : <i className="fa bg-red fa-exclamation-triangle padding-5" /> }</td>
          <td className="v-align-middle text-right">
            <Link to={detailsUrl} class="btn-rounded m-r-10 btn btn-sm btn-default">
              <i className="fa fa-pencil-alt"/> {messages.edit}
            </Link>
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <div class="text-center">
        <i class="fa fa-circle-notch fa-spin fa-fw" />
      </div>
    ) : (
      <Table responsive hover>
        <thead>
        <tr>
          {columns.map((column, i) => {
            return (
              <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                {column}
              </th>
            );
          })}
        </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );
    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.users}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            listName="clientTemplates"
            url="/api/producttemplates.json"
            urlData={urlData}
            list={list}
            sortOptions={['cdate,desc']}
          >
            <div class="panel panel-transparent">
              <div class="panel-body no-padding">
                {list.pending ? <Loader /> : <>{resultTable}</>}
              </div>
            </div>
          </List>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.clientTemplates,
  };
};

export default injectIntl(connect(mapStateToProps)(Templates));
